import { render, staticRenderFns } from "./allDetail.vue?vue&type=template&id=d5b7141e&scoped=true&"
import script from "./allDetail.vue?vue&type=script&lang=js&"
export * from "./allDetail.vue?vue&type=script&lang=js&"
import style0 from "./allDetail.vue?vue&type=style&index=0&id=d5b7141e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b7141e",
  null
  
)

export default component.exports